<div [class.selected]="domain.selected" class="domain-item">
    <!-- lock feature in case we need to lock categories
        <div [class.display-none]="recipe.unlocked" class = "recipe-overlay">
            <img src="/assets/base_icons/icon_lock.svg">
        </div>
    -->
    <img class="domain-img" src="/assets/pictos/domains/{{domain.picto}}.svg" alt={{domain.title!}}>
    <p>{{domain.title}}</p> 
</div>
